import '../../Assets/Css/Contact.css';
import { SocialIcon } from 'react-social-icons/component'
import locationIcon from '../../Assets/Images/location.png';
import phoneIcon from '../../Assets/Images/phone.png';
import emailIcon from '../../Assets/Images/email.png';
import webIcon from '../../Assets/Images/www.png';
import instagramIcon from '../../Assets/Images/instagram.png';
import youtubeIcon from '../../Assets/Images/youtube.png';
import twitterIcon from '../../Assets/Images/x.png'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" id="contact">
      <h2 className="contact-us-heading">Contact Us</h2>
      <div className="container row-layout">
        {/* Office Location */}
        <div className="contact-item text-left">
          <div className="heading">
            <img src={locationIcon} alt="Location" className="icon-img" /> <strong>Office Location</strong>
          </div>
          <p className="content">New No.27, Old No.12, Crescent Park Street, T.Nagar, Chennai, Tamil Nadu, 600017</p>
        </div>

        {/* Phone Number */}
        <div className="contact-item text-left">
          <div className="heading">
            <img src={phoneIcon} alt="Phone" className="icon-img" /> <strong>Phone Number</strong>
          </div>
          <p className="content"><a href="tel:+919876543210" className="phone-link">+91 9876-543-210</a></p>
        </div>

        {/* Email */}
        <div className="contact-item text-left">
          <div className="heading">
            <img src={emailIcon} alt="Email" className="icon-img" /> <strong>Email</strong>
          </div>
          <p className="content"><a href="mailto:contact@princepictures.com">contact@princepictures.com</a></p>
        </div>

        {/* Social Media */}
        <div className="contact-item social-media text-left">
          <div className="heading">
            <img src={webIcon} alt="Website" className="icon-img" /> <strong>Follow us on</strong>
          </div>
          <div className="social-links content">
            <a href="https://www.instagram.com/princepicturesindia/" className="instagram" target="_blank" rel="noopener noreferrer">
              <img src={instagramIcon} alt="Instagram" className="social-icon" /> Instagram
            </a>

            <a href="https://www.youtube.com/@PrincePicturesIndia" className="youtube" target="_blank" rel="noopener noreferrer">
              <img src={youtubeIcon} alt="YouTube" className="social-icon" /> YouTube
            </a>

            <a href="https://x.com/prince_pictures" className="twitter" target="_blank" rel="noopener noreferrer">
              <img src={twitterIcon} alt="Twitter" className="social-icon" /> X
            </a>

          </div>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="copyright">
        Copyright © Prince Pictures {currentYear}. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;